"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var PersonReference = require('../core/person-reference');

var CustomName = /*#__PURE__*/function () {
  function CustomName(opt) {
    _classCallCheck(this, CustomName);

    this.name = null;
    this.createdBy = null;
    this.date = null;
    this.familyId = null;
    this.inventoryId = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(CustomName, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.name = opt.name;
      this.createdBy = opt.createdBy ? new PersonReference(opt.createdBy) : null;
      this.date = new Date();
      this.familyId = new ObjectId(opt.familyId);
      this.inventoryId = new ObjectId(opt.inventoryId) || '';
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, CustomName.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'custom-name.schema.json',
        type: 'object',
        properties: {
          name: {
            type: 'string'
          },
          createdBy: {
            $ref: 'person-reference.schema.json'
          },
          date: {
            type: ['object']
          },
          familyId: {
            type: 'object'
          },
          inventoryId: {
            type: 'object'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return CustomName;
}();

tv4.addSchema(PersonReference.schema());
module.exports = CustomName;